import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-language-toggle',
    templateUrl: './language-toggle.component.html',
    standalone: false
})
export class LanguageToggleComponent {
  locales = [
    { code: 'en-CA', name: 'English' },
    { code: 'fr-CA', name: 'Français' },
  ];

  activeLocale: string; // Variable to track the selected locale

  constructor(@Inject(LOCALE_ID) private localeId: string, private router: Router) {
    this.activeLocale = localeId.toLowerCase().includes('fr') ? 'fr-CA' : 'en-CA'  //Default language in case of no match is english
  }

  changeLocale(locale: string) {
    window.location.href = window.location.href.replace(this.activeLocale, locale);
    this.activeLocale = locale;
  }

}
